import { FC } from 'react'
import {
    Outlet
} from "react-router-dom";


const PromotionPage: FC = () => {  
    return (
        <Outlet />
    );
}

export default PromotionPage